import { defineMessages } from "react-intl";

import { $t } from "../../../utils/intl";

export const somethingWentWrongTexts = defineMessages({
  title: {
    defaultMessage: "Something went wrong",
    id: "JqiqNj",
  },
  description: {
    defaultMessage: "We're sorry, but something went wrong. Please try again later.",
    id: "LOIQq+",
  },
});

export const texts = {
  title: $t(somethingWentWrongTexts.title),
  description: $t(somethingWentWrongTexts.description),
};
